// extracted by mini-css-extract-plugin
export default {"btn":"ShareButton_btn__kx4ro","disabled":"ShareButton_disabled__+sy4x"};